/* Search discovery. Native GET forms remain the source of search analytics.
   Suggestions use Liquid so customer price gates and availability stay server-side.
   No analytics calls, persistent query storage, or automatic query replacement. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var corrections = [
    [/^beauty by bees(?=\s|$)/i, 'beauty from bees'],
    [/^good protien(?=\s|$)/i, 'good protein'],
    [/\botegano\b/gi, 'oregano'], [/\btooth paste\b/gi, 'toothpaste'],
    [/\btumeric\b/gi, 'turmeric'], [/\bjuice podwer\b/gi, 'juice powder'],
    [/\bhigh potensy fish oil\b/gi, 'high potency fish oil']
  ];
  function normalize(q) { return q.trim().replace(/\s+/g, ' '); }
  function corrected(q) {
    return corrections.reduce(function (value, pair) { return value.replace(pair[0], pair[1]); }, normalize(q));
  }
  function searchURL(q) { return root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function link(label, url, className) {
    var a = document.createElement('a'); a.textContent = label; a.href = url;
    a.className = className || 'predictive__item'; return a;
  }
  function guidance(q, className) {
    var box = document.createElement('div'); box.className = 'lum-search-guidance';
    var fixed = corrected(q), lower = fixed.toLowerCase();
    if (fixed.toLowerCase() !== normalize(q).toLowerCase()) {
      box.appendChild(link('Did you mean “' + fixed + '”?', searchURL(fixed), className));
    }
    var brands = [['beauty from bees', 'Beauty From Bees'], ['good protein', 'Good Protein']];
    brands.forEach(function (brand) {
      if (lower === brand[0] || lower.indexOf(brand[0] + ' ') === 0) {
        box.appendChild(link('Explore ' + brand[1], root + 'collections/vendors?q=' + encodeURIComponent(brand[1]), className));
      }
    });
    var categories = {iron:'iron',collagen:'collagen','protein powders':'protein-powders',toothpaste:'oral-care','oral care':'oral-care'};
    if (categories[lower]) box.appendChild(link('Browse ' + (lower === 'toothpaste' ? 'oral care' : lower), root + 'collections/' + categories[lower], className));
    return box;
  }
  document.querySelectorAll('[data-search-discovery]').forEach(function (el) {
    var q = el.getAttribute('data-search-discovery');
    el.appendChild(guidance(q, 'lum-chip'));
  });
  document.querySelectorAll('[data-predictive-wrap]').forEach(function (wrap, index) {
    var input = wrap.querySelector('[data-predictive-input]');
    var panel = wrap.querySelector('[data-predictive-panel]');
    if (!input || !panel) return;
    var timer, controller, generation = 0, choices = [], mobileOpen = false, placeholder, previousOverflow, restoringFocus = false;
    var media = window.matchMedia('(max-width:1023px)');
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'lum-search-close'; close.textContent = 'Close';
    close.setAttribute('aria-label', 'Close search'); wrap.appendChild(close);
    panel.id = 'lum-search-suggestions-' + index;
    panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Search suggestions');
    input.setAttribute('aria-controls', panel.id); input.setAttribute('aria-expanded', 'false');
    var status = document.createElement('span'); status.className = 'lum-search-status';
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); wrap.appendChild(status);
    function cancel() { generation++; clearTimeout(timer); if (controller) controller.abort(); }
    function hide() {
      cancel(); panel.hidden = true; panel.replaceChildren(); choices = [];
      input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-busy'); status.textContent = '';
    }
    function openMobile() {
      if (!wrap.hasAttribute('data-mobile-search') || !media.matches || mobileOpen) return;
      mobileOpen = true; placeholder = document.createComment('Search position');
      wrap.before(placeholder); document.body.appendChild(wrap);
      previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      wrap.classList.add('is-search-open'); wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'Search Luminate');
      try { window.history.pushState(Object.assign({}, window.history.state, {lumSearch: index}), ''); } catch (e) {}
      input.focus({preventScroll: true});
      if (normalize(input.value).length < 2) show('', '', false);
    }
    function closeMobile(fromHistory, restoreFocus) {
      if (!mobileOpen) { hide(); return; }
      mobileOpen = false; hide(); wrap.classList.remove('is-search-open');
      wrap.removeAttribute('role'); wrap.removeAttribute('aria-modal'); wrap.removeAttribute('aria-label');
      if (placeholder && placeholder.parentNode) placeholder.replaceWith(wrap);
      document.body.style.overflow = previousOverflow || '';
      if (!fromHistory && window.history.state && window.history.state.lumSearch === index) window.history.back();
      if (restoreFocus !== false) { restoringFocus = true; input.focus({preventScroll: true}); restoringFocus = false; }
    }
    function show(html, q, failed) {
      panel.innerHTML = html;
      if (q) panel.prepend(guidance(q));
      if (failed) { var p = document.createElement('p'); p.className = 'predictive__none'; p.textContent = 'Suggestions are taking a moment. Search to see full results.'; panel.appendChild(p); }
      if (q) panel.appendChild(link('See all results for “' + q + '”', searchURL(q), 'predictive__all'));
      else { var p = document.createElement('p'); p.className = 'predictive__none'; p.textContent = 'Find your favourites. Search by product, brand, category or ingredient.'; panel.appendChild(p); }
      choices = Array.from(panel.querySelectorAll('a'));
      panel.hidden = false; input.setAttribute('aria-expanded','true'); input.removeAttribute('aria-busy');
      status.textContent = q ? choices.length + ' suggestions. Use the down arrow to explore, or Tab to reach Add buttons.' : '';
    }
    function request() {
      cancel(); var q = normalize(input.value), ticket = generation;
      if (q.length < 2) { if (mobileOpen) show('', '', false); else hide(); return; }
      panel.replaceChildren(); choices = []; panel.hidden = true; input.setAttribute('aria-expanded','false');
      input.setAttribute('aria-busy','true'); status.textContent = 'Searching…';
      timer = setTimeout(function () {
        controller = new AbortController();
        fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=lum-predictive-search&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last', {signal: controller.signal})
          .then(function (res) { if (!res.ok) throw new Error('Suggestions unavailable'); return res.text(); })
          .then(function (html) {
            if (ticket !== generation) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-lum-predictive-results]');
            if (!results) throw new Error('Missing suggestions section');
            show(results.innerHTML, q, false);
          }).catch(function (error) { if (ticket === generation && error.name !== 'AbortError') show('', q, true); });
      }, 200);
    }
    function activateSearch() {
      document.dispatchEvent(new CustomEvent('luminate:search-open'));
      openMobile();
    }
    input.addEventListener('input', function () { activateSearch(); request(); });
    input.addEventListener('click', activateSearch);
    input.addEventListener('focus', function () {
      if (restoringFocus) return;
      activateSearch();
      if (panel.hidden && normalize(input.value).length >= 2) request();
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (mobileOpen) closeMobile(false); else { hide(); restoringFocus = true; input.focus(); restoringFocus = false; } return; }
      if (mobileOpen && e.key === 'Tab') {
        var focusable = Array.from(wrap.querySelectorAll('input:not([type="hidden"]),button:not(:disabled),select:not(:disabled),a[href]')).filter(function (el) { return !el.closest('[hidden]') && el.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      if (panel.hidden || !choices.length || e.target.matches('select,button')) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var at = choices.indexOf(document.activeElement);
        if (e.target !== input && at < 0) return;
        e.preventDefault();
        var next = at < 0 ? (e.key === 'ArrowDown' ? 0 : choices.length - 1) : at + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) input.focus();
        else choices[next % choices.length].focus();
      }
    });
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-search-variant]')) return;
      var button = e.target.form.querySelector('button[type="submit"]'); if (button) button.disabled = !e.target.value;
    });
    wrap.addEventListener('focusout', function (e) { if (!mobileOpen && !wrap.contains(e.relatedTarget)) hide(); });
    document.addEventListener('click', function (e) { if (!mobileOpen && !wrap.contains(e.target)) hide(); });
    close.addEventListener('click', function () { closeMobile(false); });
    window.addEventListener('popstate', function () { if (mobileOpen && (!window.history.state || window.history.state.lumSearch !== index)) closeMobile(true); });
    media.addEventListener('change', function () { if (!media.matches && mobileOpen) closeMobile(false, false); });
    function closeForCart() { if (mobileOpen) closeMobile(false, false); else hide(); }
    document.addEventListener('luminate:cart-open', closeForCart);
    document.addEventListener('luminate:cart-add-success', closeForCart);
    document.addEventListener('focusin', function (e) { if (mobileOpen && !wrap.contains(e.target)) input.focus({preventScroll:true}); });
    var form = input.closest('form'); if (form) form.addEventListener('submit', function () {
      if (mobileOpen) {
        closeMobile(true, false);
        if (window.history.state && window.history.state.lumSearch === index) { var state = Object.assign({}, window.history.state); delete state.lumSearch; window.history.replaceState(state, ''); }
      } else hide();
    });
  });
})();
